/**
 * @description The pathnames list from the spreadsheet that are indexable.
 * @link https://docs.google.com/spreadsheets/d/1KJQHgUqpP6byCIc2rZkztAUsLCIJxHpfSLKlgKxtvxc/edit?gid=0#gid=0
 */
import indexedPathnames from './indexedPathnames.json';

/**
 * @description Checks if the PLP pathname is indexable.
 * It returns `true` if not a search page, i.e the PLP pathname does not include `'q-'`
 * or if it includes any of the indexed pathnames in the spreadsheet referenced above.
 * @param {string} pathname PLP pathname
 * @return {boolean} `true` if the pathname is indexable, `false` otherwise.
 */
export const isIndexable = (pathname: string) => {
  if (!pathname.includes('q-')) {
    return true;
  }
  const formattedPathname = pathname.endsWith('/') ? pathname : `${pathname}/`;
  const isMatching = indexedPathnames.some((segment) => formattedPathname.includes(segment));
  return isMatching;
};
